import { InputComponentType } from "./../common/component/input/input";
import { IDomain, HtmlType } from "../common/dto/idomain";
import { formatNumber } from "../common/field/renderer";

class Identifier implements IDomain<number> {

    public htmlType: HtmlType = "text";
    public inputComponent: InputComponentType = "textField";

    public format(valueToFormat?: number) {
        if (valueToFormat !== undefined && valueToFormat !== null) {
            return valueToFormat.toString();
        }
        return "";
    }

    public unformat(valueToUnformat: string) {
        if (valueToUnformat) {
            const escaped = formatNumber(valueToUnformat);
            if (escaped) {
                return +escaped;
            }
        }
        return undefined;
    }

    public validators = [];
}

export const identifier = new Identifier();
